import React from "react";
import {
  Alert,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
}

export const SuccessDialog: React.FC<SuccessDialogProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {t("paygap.employeeData.dialog.success.title")}
        <IconButton onClick={onClose} size="small">
          <FeatherIcon icon="x" size={18} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Alert severity="success">
          <Typography variant="body2">
            <strong>{t("paygap.employeeData.dialog.success.message")}</strong>
          </Typography>
        </Alert>
      </DialogContent>
    </Dialog>
  );
};
